import React from 'react'
import Navigation from '../../../layout/Navigation/Navigation';
import { myPages } from "../../../menu";
import useDeviceScreen from "../../../hooks/useDeviceScreen";

const CommonHeaderLeft = () => {
	const { width } = useDeviceScreen();

    return (
        <Navigation
            menu={myPages}
            id="my-pages"
            horizontal={
                !!width && width >= Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
            }
        />
    )
}

export default CommonHeaderLeft